import ItemFilter, { type FilterOption } from './ItemFilter';

export type ModeFilterValue =
  | 'velocity'
  | 'planningAccuracy'
  | 'pointsPerPerson';

export default class ModeFilter extends ItemFilter<ModeFilterValue> {
  constructor({
    initialItems = ['velocity'],
  }: { initialItems?: ModeFilterValue[] } = {}) {
    const initialOptions = ModeFilter.initOptions();
    super(initialItems, initialOptions);
  }

  static initOptions(): FilterOption<ModeFilterValue>[] {
    return [
      { text: 'Velocity', value: 'velocity' },
      {
        text: 'Planning accuracy',
        value: 'planningAccuracy',
      },
      {
        // Note we actually dynamically label this in the UI based on capacity units,
        text: 'Points per person',
        value: 'pointsPerPerson',
      },
    ];
  }
}
